import * as React from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components";

export const GetAccountBalanceListColumns = (type: Dati.TDictTipo) => [
    {
        name: "ID_EstrattoConto",
        label: Trad.Trad("EstrattoConto"),
        options: {
            filter: false
        }
    },
    {
        name: "AnagDa",
        label: Trad.Trad("Da"),
        options: {
            filter: false
        }
    },
    {
        name: "AnagA",
        label: Trad.Trad("A"),
        options: {
            filter: false
        }
    },
    {
        name: "DataDa",
        label: Trad.Trad("DataDa"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Glob.DataValoreTrad(val)
        }
    },
    {
        name: "DataA",
        label: Trad.Trad("DataA"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Glob.DataValoreTrad(val)
        }
    },
    {
        name: "Totale",
        label: Trad.Trad("Totale"),
        options: {
            filter: false,
            customBodyRender: (val: number) => Trad.TradParam("{1-I}", [val])
        }
    },
    {
        name: "ID_TipoEstrattoContoStato",
        label: Trad.Trad("Stato"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(type[val].Valore ?? "")
        }
    },
    {
        name: "ID_EstrattoConto",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => (
                <a href={`/EstrattoConto/${val}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </a>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/SearchTableColumns/AccountBalanceListColumns.tsx